module.exports = __webpack_public_path__ + "static/media/invite-w.b0da4063.svg";